import { Fragment, SetStateAction, useCallback } from 'react'
import PermissionChecker from '../../../../../../../baseComponents/PermissionChecker'
import { TwinDictionary, addDictionaryExtraLine, dictionaryComplexFromJsonArr } from '../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import { InputHidden } from '../../../../../../../forms/Input'
import CustomSelectCContactInfo from '../../../../../../Customers/CustomerCustomSelectContactInfo'

export interface ModalCreateEditCustomerContactData {
    CustomerId: string | number
    CustomerContactPersonId?: number | null
}

interface ShareQuoteCContactPersonSelectorParentProps extends ShareQuoteCContactPersonSelectorProps { 
    extraProps: TwinDictionary
}

export const ShareQuoteCContactPersonSelectorParent: React.FC<ShareQuoteCContactPersonSelectorParentProps> = ({ handleOpenModalBig, customerData, setCustomerData, extraProps }) => {
    if (extraProps?.CustomerContactPersonId) {
        return <ShareQuoteCContactPersonSelectorEdit handleOpenModalBig={handleOpenModalBig} customerData={customerData} setCustomerData={setCustomerData} customerContacts={extraProps?.customerContacts}  />
    }
    return <ShareQuoteCContactPersonSelectorCreate handleOpenModalBig={handleOpenModalBig} customerData={customerData} setCustomerData={setCustomerData} customerContacts={extraProps?.customerContacts}  />
}

interface ShareQuoteCContactPersonSelectorProps {
    handleOpenModalBig: (modalType: string | null) => void
    setCustomerData: (value: SetStateAction<ModalCreateEditCustomerContactData>) => void
    customerData: ModalCreateEditCustomerContactData
    customerContacts: TwinDictionary[] | null
}

const ShareQuoteCContactPersonSelectorEdit: React.FC<ShareQuoteCContactPersonSelectorProps> = ({ handleOpenModalBig, setCustomerData, customerData, customerContacts }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.contactPerson')} permission={'update'} >
            <CustomSelectContactInfo setCustomerData={setCustomerData} customerData={customerData} customerContacts={customerContacts || null} handleOpenModalBig={handleOpenModalBig} />
            <div className='ml-auto text-12 -mt-8 cursor-pointer' onClick={() => handleOpenModalBig('editContactPerson')}>{t('editContactPerson', 'Editar persona de contacto')}</div>
        </PermissionChecker>
    )
}

const ShareQuoteCContactPersonSelectorCreate: React.FC<ShareQuoteCContactPersonSelectorProps> = ({ handleOpenModalBig, customerData, setCustomerData, customerContacts }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.contactPerson')} permission={'create'} >
            <CustomSelectContactInfo customerContacts={customerContacts || null}  handleOpenModalBig={handleOpenModalBig} setCustomerData={setCustomerData} customerData={customerData} />
            <div className='ml-auto text-12 -mt-8 cursor-pointer' onClick={() => handleOpenModalBig('newContactPerson')}>{t('addNewContactPerson', 'Añadir nueva persona de contacto')}</div>
        </PermissionChecker>
    )
}

interface CustomSelectContactInfoProps extends CustomSelectContactInfoLogicProps { 
    customerData: ModalCreateEditCustomerContactData
    customerContacts: TwinDictionary[] | null
}

const CustomSelectContactInfo: React.FC<CustomSelectContactInfoProps> = ({ setCustomerData, customerData, handleOpenModalBig, customerContacts }) => {
    const { t } = useTwinTranslation()
    const { handleOnChange } = useCustomSelectContactInfoLogic({ setCustomerData, handleOpenModalBig })
    const parsedContacts = addDictionaryExtraLine(dictionaryComplexFromJsonArr(customerContacts || {}))
    const choosenCustomerContactId = customerData?.CustomerContactPersonId
    const selectedContactPerson = choosenCustomerContactId ? parsedContacts?.[choosenCustomerContactId] : undefined
    return (
        <Fragment>
            <CustomSelectCContactInfo selectedContact={selectedContactPerson} id={selectedContactPerson?.id} sortItems={true} items={parsedContacts} label={t('customerContact', 'Contacto del cliente')} name='CustomerContactPersonId' required={true} value={choosenCustomerContactId || undefined} onChange={handleOnChange} />
            <InputHidden name='shared_email' value={selectedContactPerson?.email}></InputHidden>
        </Fragment>
    )
}

interface CustomSelectContactInfoLogicProps {
    handleOpenModalBig: (modalType: string | null) => void
    setCustomerData: (value: SetStateAction<ModalCreateEditCustomerContactData>) => void
}

const useCustomSelectContactInfoLogic = ({ handleOpenModalBig, setCustomerData }: CustomSelectContactInfoLogicProps) => {
    const handleOnChange = useCallback(async (contact: any) => {
        handleOpenModalBig(null)
        setCustomerData((old) => ({ ...old, CustomerContactPersonId: parseInt(contact) }))
    }, [handleOpenModalBig, setCustomerData])

    return { handleOnChange }
}